// import styles
import "./ListaProgetti.css";

// import pacchetti
import { Link } from "react-router-dom";
import format from "date-fns/format";
import { it } from "date-fns/locale";

// import hooks
import { useAuthContext } from "../hooks/useAuthContext";

export default function ListaSpese({ data, visible }) {
  const { user } = useAuthContext();

  return (
    <div className="project-list">
      {data.length === 0 && <p>Nessuna Spesa disponibile</p>}
      {data.map((spesa) => (
        <Link
          to={`/spesa/${spesa.id}`}
          key={spesa.id}
          className={visible || spesa.isVisible ? "" : "nascondi"}
        >
          <h4>{spesa.nome}</h4>
          <div className="assigned-to">
            <p>
              Data: {format(spesa.data.toDate(), "d MMM y", { locale: it })}
            </p>
            <p>Importo: {spesa.importo} €</p>
            {user.admin && <p>Autore: {spesa.autore.displayName}</p>}
          </div>
        </Link>
      ))}
    </div>
  );
}
